import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { ThemeContext } from "./contexts/ThemeContext";
import { Main, ProjectPage } from "./pages";
import { BackToTop } from "./components";
import ScrollToTop from "./utils/ScrollToTop";

import "./App.css";
import Maintenance from "./components/Maintance";

function App() {
  const { theme } = useContext(ThemeContext);

  console.log("%cBikash Shrestha", `color:${theme.primary}; font-size:20px`);
  // console.log = console.warn = console.error = () => {};

  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/" exact component={Main} />
          {/* <Route path="/blogs" exact component={BlogPage} />   */}
          <Route path="/blogs" exact component={Maintenance} />  
          <Route path="/projects" exact component={ProjectPage} />
          <Route path="/academic-projects" exact component={Maintenance} />

          <Redirect to="/" />
        </Switch>
      </Router>
      <BackToTop />
    </div>
  );
}

export default App;
